module.exports = __webpack_public_path__ + "media/woodpacking_notification_en.bb2a479c.mp3";